import { Form, Panel, Table } from 'react-bootstrap';
import styled from "styled-components"

interface IGridWrapperProps {
    highlight?: boolean
}

export const GridWrapper = styled.div<IGridWrapperProps>`
    height: 82vh;
    
    font-family: Roboto;

    // .action-menu > .ag-cell-wrapper > .ag-cell-value {
    //     overflow: visible;
    //     border-bottom: none;
    //     line-height: 28px;
    //     border-color: #ccc;
    // }

    .action-menu {
        overflow: visible;
        /* border-bottom: none; */
        // line-height: 33px;
        /* border-color: #ccc; */
        display: flex;
        align-items: center;
        border: 0 none;
    }

    .action-menu > .ag-react-container {
        width: 100%;
    }

    .action-menu.ag-cell-focus{
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        background-color: #133366;
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-size: 14px;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row:hover {
        background-color: ${p => p.highlight != undefined ? 'yellow' : null};
    }

    .ag-row-selected > .ag-cell {
        background-color: yellow !important;
        color: black;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    // .list-header {
    //     display: flex;
    //     justify-content: center;
    //     align-items: flex-end;
    //     padding-bottom: 4px;
    //     color: #fff;
    // }

    // .list-cell {
    //     border-bottom: none;
    //     text-align: center;
    //     line-height: 28px;
    //     border-color: #ccc;
    //     font-size: 14px;
    //     justify-content: center;
    //     display: flex;
    // }

    .list-cell {
        //border-bottom: none;
        text-align: center;
        line-height: 26px;
        //border-color: #ccc;
        // font-size: 12px;
        border: 0 none;
        border-right: 1px solid #ddd;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        border-right: 1px solid white;
        color: white;
    }

    .customHeaderLabel {
        text-align: center;
    }
`;

export const ContactsTableWrapper = styled(Table)`
    font-size: 12px;
    margin-bottom: 10px;
    
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }

    & > tbody > tr > td {
        vertical-align: middle;
        padding-top: 3px;
        padding-bottom: 3px;
    }
`;

export const ContactPanelBodyWrapper = styled(Panel.Body)`
    .form-group {
        margin-bottom: 5px;
    }

    .form-group > label {
        margin-bottom: 2px;
    }
`;

export const AddEditFormWrapper = styled(Form)`
    .form-group {
        margin-bottom: 10px;
    }

    .help-block {
        margin-bottom: 0px;
    }
`;

export const DeleteWrapper = styled(Form)`
    margin-bottom: 20px;
    
    .form-group {
        margin-bottom: 5px;
    }
`;